module.exports = {"home":"Home"}


//////////////////
// WEBPACK FOOTER
// ./src/app/translations/lv.json
// module id = 2RWU
// module chunks = 3